import * as Sentry from "@sentry/react";
import "@mantine/core/styles.css";
import "@mantine/carousel/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/dropzone/styles.css";
import "@mantine/notifications/styles.css";
import { RouterProvider } from "react-router-dom";

import { FallbackComponent } from "#app/monitoring/FallbackComponent";

import { ReactQueryProvider } from "./app/http/ReactQueryProvider";
import { router } from "./app/routes/router";

const App = () => {
  return (
    <Sentry.ErrorBoundary fallback={FallbackComponent} showDialog={false}>
      <ReactQueryProvider>
        <RouterProvider router={router} />
      </ReactQueryProvider>
    </Sentry.ErrorBoundary>
  );
};

export default App;
